module.exports = {
  title: '淮南市精锐科技学校管理系统',
  fixedHeader: false,
  sidebarLogo: true,
  showSettings: false
}
